import { HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Params, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ZipCodes } from '../../../features-common/constants/ZipCodes';
import Swal from 'sweetalert2';
import { ProvidersService } from '../providers.service';

@Component({
  selector: 'app-add-provider',
  templateUrl: './add-provider.component.html',
  styleUrls: ['./add-provider.component.scss']
})
export class AddProviderComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  @Input() salesReps
  @Input() businessTypes
  @Input() pricelists
  selectedstate;
  offHoursTransactionCount;
  offHoursTransactionAmount;
  thresholdAmount;
  usStateZips;
  addProviderForm: FormGroup;
  emailRegx = /^(([^<>+()\[\]\\.,;:\s@"-#$%&=]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;
  phoneRegx = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
  autoReloadStatus = false;
  creditLineStatus = false;
  ipAddressStatus = false;
  ivrAccess = false;
  emailNotificationStatus = false;
  transactionAmtPerhr: number[];
  smsNotificationStatus = false;
  mobileNumber = new FormControl();
  filteredOptions: Observable<string[]>;
  salesRepsOptions: any = [];
  accountType = new FormControl('Prepaid');
  public phone: Array<string | RegExp>
  transactionPerHr: number[];

  constructor(private cdref: ChangeDetectorRef, private fb: FormBuilder, public dialog: MatDialog, private router: Router, private providersService: ProvidersService) {
    super();

    this.phone = ['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  }

  ngAfterContentChecked() {

    this.cdref.detectChanges();

  }

  charMask(rawValue: string): RegExp[] {
    const mask = /^[A-Z|a-z|0-9| ]+$/;
    const strLength = String(rawValue).length;
    const nameMask: RegExp[] = [];

    for (let i = 0; i <= strLength; i++) {
      nameMask.push(mask);
    }

    return nameMask;

  }
  charsMaskNoSpace(rawValue: string): RegExp[] {
    const mask = /^[A-Z|a-z|0-9|]+$/;
    const strLength = String(rawValue).length;
    const userNameMask: RegExp[] = [];

    for (let i = 0; i <= strLength; i++) {
      userNameMask.push(mask);
    }

    return userNameMask;

  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['salesReps']) {
      this.salesReps = changes['salesReps'].currentValue;
     
    }
    if (changes['businessTypes']) {
      this.businessTypes = changes['businessTypes'].currentValue;
    }
    if (changes['pricelists']) {
      this.pricelists = changes['pricelists'].currentValue;
    }
  }

  checkIsCreditline(e) {
    this.creditLineStatus = e.checked;
    // if (this.creditLineStatus) {
    //   this.addProviderForm.get("createCreditLine").setValidators(Validators.required);

    // } else {
    //   this.addProviderForm.get("createCreditLine").clearValidators();
    // }
  }
  checkIpAddressStatus(e) {
    this.ipAddressStatus = e.checked;
    // if (this.ipAddressStatus) {
    //   this.addProviderForm.get("ipAddressStatus").setValidators(Validators.required);

    // } else {
    //   this.addProviderForm.get('ipAddressStatus').setValue(null);
    //   this.addProviderForm.get("ipAddressStatus").clearValidators();
    // }
  }
  checkIsIvr(e) {
    this.ivrAccess = e.checked;
    // if (this.ivrAccess) {
    //   this.addProviderForm.get("ivrNumber").setValidators(Validators.required);
    //   this.addProviderForm.get("ivrCode").setValidators(Validators.required);

    // } else {
    //   this.addProviderForm.get("ivrNumber").clearValidators();
    //   this.addProviderForm.get("ivrCode").clearValidators();
    // }
  }
  checkautoReloadStatus(e) {
    this.autoReloadStatus = e.checked;
    // if (this.autoReloadStatus) {
    //   this.addProviderForm.get("autoReloadAmount").setValidators(Validators.required);
    // } else {
    //   this.addProviderForm.get("autoReloadAmount").clearValidators();
    // }
  }

  checkIsTextNotify(e) {
    this.smsNotificationStatus = e.checked;
  }
  checkEmailNotificationStatusNotify(e) {
    this.emailNotificationStatus = e.checked;
  }

  ngOnInit(): void {
    //super.ngOnInit();
    this.offHoursTransactionCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    this.offHoursTransactionAmount = [25, 50, 75, 100, 125, 150, 175, 200];
    this.thresholdAmount = [25, 50, 75, 100, 125, 150, 175, 200, 225, 250];
    this.transactionAmtPerhr = [25, 50, 75, 100, 125];
    this.transactionPerHr = [10, 20, 30, 40, 50];
    this.usStateZips = ZipCodes.USAStatesShort;

    this.initForm();

  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.salesRepsOptions.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  private initForm() {
    this.addProviderForm = this.fb.group({
      providerName: ['', [Validators.required]],
      contactName: ['', [Validators.required]],
      mobileNumber: ['', [Validators.required, Validators.pattern(this.phoneRegx)]],
      email: ['', [Validators.required, Validators.pattern(this.emailRegx)]],
      providerStatus: ['', [Validators.required]],
      address: [''],
      city: [''],
      state: [''],
      zipCode: ['', [Validators.minLength(5), Validators.maxLength(5)]],

    })
  }

  get f() {
    return this.addProviderForm.controls;
  }

  onSubmit() {
   
    if (this.addProviderForm.valid) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          message: 'pages.placeholders.Areyousureyouwanttosavethechanges',
          buttonText: {
            ok: 'pages.placeholders.Save',
            cancel: 'pages.placeholders.cancel'
          }
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.setSubmitParameters(this.addProviderForm)
        }else{
          this.router.navigate(['dashboard/providers/providers-dashboard'])
        }
      });

    }
    //
  }

  setSubmitParameters(addProviderForm: FormGroup) {

    let httpParams: Params = {
      providerName: addProviderForm.get('providerName').value,
      contactName: addProviderForm.get('contactName').value,
      mobileNumber: addProviderForm.get('mobileNumber').value.replace(/\D+/g, '').substring(1),
      email: addProviderForm.get('email').value,
      providerStatus: addProviderForm.get('providerStatus').value,
      address1: addProviderForm.get('address').value,
      city: addProviderForm.get('city').value,
      state: addProviderForm.get('state').value,
      zip: addProviderForm.get('zipCode').value.toString()
    }
    //

    this.providersService.addNewProvider(httpParams).subscribe(res => {
        if (res && res) {
          if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_110") || res.responseStatus == 'Success'){
            this.router.navigate(['features/providers/allproviders'])
            this.toastrService.success('Added Provider successfully', 'Success', {
              timeOut: 3000,
            });        
        }else if (res && res.httpcode == 400) {
            Swal.fire(
              {
                title: 'Failure',
                text: 'Update provider failed',
                icon: 'error',
                timer: 2000
              }
            )
          }else{
            Swal.fire(
              {
                title: res.responseStatus,
                text: res.userMessage,
                icon: 'error',
                timer: 2000,
                willClose: () => {
    
                }
              })  
          }  
      }
    });
  }


  onCancel() {
    for (const name in this.addProviderForm.controls) {
      if (this.addProviderForm.controls[name].invalid) {
       
      } else {
       
      }
    }

    const dialogRefCancel = this.dialog.open(DialogComponent, {
      data: {
        message: 'pages.placeholders.Areyousureyouwanttocancelthechanges',
        buttonText: {
          ok: 'pages.newRetailer.yes',
          cancel: 'pages.newRetailer.cancel'
        }
      }
    });

    dialogRefCancel.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        //this.addProviderForm.reset()
        //window.location.reload()

        this.router.navigateByUrl('features/providers/allproviders')
      }
    });
  }

}